import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import logo from '../../assets/report/logo.png';
import a from '../../assets/report/a.png';
import globe from '../../assets/report/globe.png';
import mob from '../../assets/report/mob.png';
import ins from '../../assets/report/ins.png';
import lin from '../../assets/report/lin.png';

const LiveReport = () => {
  const { imei } = useParams();
  const [reportData, setReportData] = useState(null);
  const [carouselImages, setCarouselImages] = useState([]);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    fetch(`https://live.callcenter.buybackbooth.com/Scripts/Gearvana/CC_GetSessionFromIMEI.php?imei=${imei}`)
      // fetch(`https://dev.callcenter.buybackbooth.com/Scripts/WebDuo/CC_GetUpToPrice.php`)
      .then((response) => response.json())
      .then((data) => {
        const report = data?.data?.[0] || {};
        setReportData(report);

        // Extract images for the carousel
        const images = [];

        if (report.assets) {
          // Extract bin images
          if (report.assets.bin) {
            report.assets.bin.forEach(bin => {
              if (bin.top?.url) images.push({ original: bin.top.url, thumbnail: bin.top.url });
              if (bin.bottom?.url) images.push({ original: bin.bottom.url, thumbnail: bin.bottom.url });
            });
          }

          // // Extract card images
          // if (report.assets.card) {
          //   report.assets.card.forEach(card => {
          //     if (card.front?.url) images.push({ original: card.front.url, thumbnail: card.front.url });
          //     if (card.back?.url) images.push({ original: card.back.url, thumbnail: card.back.url });
          //   });
          // }

          // Extract screens images
          if (report.assets.screens) {
            report.assets.screens.forEach(screen => {
              if (screen.images) {
                screen.images.forEach(image => {
                  if (image.url) images.push({ original: image.url, thumbnail: image.url });
                });
              }
            });
          }
        }

        setCarouselImages(images);
      })
      .catch((error) => console.error("Error fetching report data:", error));
  }, [imei]);



  // useEffect(() => {
  //   if (!reportData?.device) return;

  //   const payload = {
  //     brand: reportData.device.brand,
  //     model: reportData.device.model,
  //     storage: reportData.device.capacity + "GB",
  //     carrier: reportData.device.carrier
  //   };

  //   // fetch("https://live.callcenter.buybackbooth.com/Scripts/Gearvana/CC_endpoint.php", {
  //   //   method: "POST",
  //   //   headers: {
  //   //     "Content-Type": "application/json"
  //   //   },
  //   //   body: JSON.stringify(payload)
  //   // })
  //   fetch("http://localhost:8080/api/cc-endpoint", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json"
  //     },
  //     body: JSON.stringify(payload)
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       console.log("CC_endpoint response:", data);
  //     })
  //     .catch((err) => {
  //       console.error("Error calling CC_endpoint:", err);
  //     });

  // }, [reportData]);

  useEffect(() => {
    if (!reportData?.device) return;

    const payload = {
      brand: reportData.device.brand,
      model: reportData.device.model,
      storage: reportData.device.capacity + "GB",
      carrier: reportData.device.carrier
    };
      
    fetch("https://srv801875.hstgr.cloud/api/cc-endpoint", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    })
      .then(res => res.json())
      .then(data => {
        console.log("CC_endpoint response:", data);
      })
      .catch(err => {
        console.error("Error calling CC_endpoint:", err);
      });

  }, [reportData]);

  if (!reportData || Object.keys(reportData).length === 0) {
    return <div className="loading">Loading report...</div>;
  }
  
  const handleScreenChange = (fullscreen) => {
    setIsFullscreen(fullscreen);
  };

  return (

    <div className="p-6 bg-gray-100 rounded-lg shadow-md max-w-6xl mx-auto live-report-container">
      <header className="p-0 bg-transparent">
        <div className="flex items-center justify-center">
          <div className="flex-shrink-0">
            <a
              className="App-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={logo} className="App-logo mb-4" alt="logo" />
            </a>
          </div>
        </div>
      </header>



      <div className="text-center my-8">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900">
          Device Report
        </h1>
        <p className="text-lg sm:text-xl text-gray-700 mt-2">
          {reportData.device?.model} &mdash; IMEI: {imei}
        </p>
      </div>

      <div className="flex justify-center">
        <div className="flex justify-center items-center space-x-10">
          <div className="phone-value-button my-3">
            Grade: {reportData.grading?.grade}
          </div>
          <div className="phone-value-button my-3">
            Offer Price: ${reportData.price} USD
          </div>
        </div>
      </div>





      <h3 className="text-lg font-semibold my-3">Session Details</h3>
      <div className="border p-4 rounded bg-white shadow-sm space-y-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="flex justify-between items-center p-3 rounded border border-gray-300 bg-gray-50">
            <span className="text-sm font-medium text-gray-700">Session ID</span>
            <span className="text-sm font-semibold text-gray-800">{reportData.sessionId}</span>
          </div>
          <div className="flex justify-between items-center p-3 rounded border border-gray-300 bg-gray-50">
            <span className="text-sm font-medium text-gray-700">Date</span>
            <span className="text-sm font-semibold text-gray-800">{reportData.date}</span>
          </div>
          <div className="flex justify-between items-center p-3 rounded border border-gray-300 bg-gray-50">
            <span className="text-sm font-medium text-gray-700">End Method</span>
            <span className="text-sm font-semibold text-gray-800">{reportData.endMethod}</span>
          </div>
          <div className="flex justify-between items-center p-3 rounded border border-gray-300 bg-gray-50">
            <span className="text-sm font-medium text-gray-700">Agent</span>
            <span className="text-sm font-semibold text-gray-800">{reportData.agent}</span>
          </div>
        </div>
      </div>


      <h3 className="text-lg font-semibold my-3">Device Details</h3>
      <div className="border p-4 rounded bg-white shadow-sm space-y-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="flex justify-between items-center p-3 rounded border border-gray-300 bg-gray-50">
            <span className="text-sm font-medium text-gray-700">Brand</span>
            <span className="text-sm font-semibold text-gray-800">{reportData.device?.brand}</span>
          </div>
          <div className="flex justify-between items-center p-3 rounded border border-gray-300 bg-gray-50">
            <span className="text-sm font-medium text-gray-700">Model</span>
            <span className="text-sm font-semibold text-gray-800">{reportData.device?.model}</span>
          </div>
          <div className="flex justify-between items-center p-3 rounded border border-gray-300 bg-gray-50">
            <span className="text-sm font-medium text-gray-700">IMEI</span>
            <span className="text-sm font-semibold text-gray-800">{reportData.device?.imei}</span>
          </div>
          <div className="flex justify-between items-center p-3 rounded border border-gray-300 bg-gray-50">
            <span className="text-sm font-medium text-gray-700">Storage</span>
            <span className="text-sm font-semibold text-gray-800">{reportData.device?.capacity} GB</span>
          </div>
          <div className="flex justify-between items-center p-3 rounded border border-gray-300 bg-gray-50">
            <span className="text-sm font-medium text-gray-700">Carrier</span>
            <span className="text-sm font-semibold text-gray-800">{reportData.device?.carrier}</span>
          </div>
        </div>
      </div>


      <h3 className="text-lg font-semibold my-3">Condition</h3>
      <div className="border p-4 rounded bg-white shadow-sm">
        {reportData.grading?.condition && (
          <div className="space-y-4">
            {/* Functional Status */}
            <div className="flex items-center space-x-2">
              <span className="text-base font-semibold">Functional:</span>
              <span
                className={`px-2 py-1 rounded text-white text-sm font-medium ${!reportData.grading.condition.NotFunctional ? "bg-green-600" : "bg-red-600"
                  }`}
              >
                {!reportData.grading.condition.NotFunctional ? "✅ Fully Functional" : "⚠️ Needs Attention"}
              </span>
            </div>

            {/* Other Conditions */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {Object.entries(reportData.grading.condition)
                .filter(([key]) => key !== "NotFunctional")
                .map(([key, value]) => (
                  <div
                    key={key}
                    className={`flex justify-between items-center p-3 rounded border ${value ? "bg-red-50 border-red-300" : "bg-green-50 border-green-300"
                      }`}
                  >
                    <span className="text-sm font-medium text-gray-700">
                      {key.replace(/([A-Z])/g, ' $1')}
                    </span>
                    <span
                      className={`text-xs font-semibold px-2 py-1 rounded ${value
                        ? "bg-red-100 text-red-800"
                        : "bg-green-100 text-green-800"
                        }`}
                    >
                      {value ? "Issue Found" : "No"}
                    </span>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>




      <h3 className="text-lg font-semibold my-3">Price Details</h3>
      <div className="border p-4 rounded bg-white shadow-sm space-y-3">
        <div className="flex justify-between items-center p-3 rounded border border-blue-300 bg-blue-50">
          <span className="text-sm font-medium text-gray-700">Offer Price (Your Price)</span>
          <span className="text-sm font-semibold text-blue-800">${reportData.price} USD</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="flex justify-between items-center p-3 rounded border border-gray-300 bg-gray-50">
            <span className="text-sm font-medium text-gray-700">New Condition Price</span>
            <span className="text-sm font-semibold text-gray-800">${reportData.allPrices?.new}</span>
          </div>
          <div className="flex justify-between items-center p-3 rounded border border-green-300 bg-green-50">
            <span className="text-sm font-medium text-gray-700">Good Condition Price</span>
            <span className="text-sm font-semibold text-green-800">${reportData.allPrices?.good}</span>
          </div>
          <div className="flex justify-between items-center p-3 rounded border border-yellow-300 bg-yellow-50">
            <span className="text-sm font-medium text-gray-700">Bad Condition Price</span>
            <span className="text-sm font-semibold text-yellow-800">${reportData.allPrices?.bad}</span>
          </div>
          <div className="flex justify-between items-center p-3 rounded border border-red-300 bg-red-50">
            <span className="text-sm font-medium text-gray-700">Recycle Value</span>
            <span className="text-sm font-semibold text-red-800">${reportData.allPrices?.recycle}</span>
          </div>
        </div>
      </div>


      <h3 className="text-lg font-semibold my-3">Blacklist Info</h3>
      <div className="border p-4 rounded bg-white shadow-sm space-y-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="flex justify-between items-center p-3 rounded border border-gray-300 bg-gray-50">
            <span className="text-sm font-medium text-gray-700">Blacklist Status</span>
            <span className="text-sm font-semibold text-gray-800">
              {reportData.blacklistCheck?.Remarks || "N/A"}
            </span>
          </div>
          <div className="flex justify-between items-center p-3 rounded border border-gray-300 bg-gray-50">
            <span className="text-sm font-medium text-gray-700">Response Status</span>
            <span className="text-sm font-semibold text-gray-800">
              {reportData.blacklistCheck?.RawResponse?.responsestatus || "N/A"}
            </span>
          </div>
          <div className="flex justify-between items-center p-3 rounded border border-gray-300 bg-gray-50">
            <span className="text-sm font-medium text-gray-700">Greylist Status</span>
            <span className="text-sm font-semibold text-gray-800">
              {reportData.blacklistCheck?.RawResponse?.greyliststatus || "N/A"}
            </span>
          </div>
        </div>
      </div>


      {/* Image Gallery */}
      <section  >
        <div className="container" >
          <div className="row pt-3" >
            <div className="img-box" style={{ width: '50%', margin: '0 auto' }}>
              {carouselImages.length > 0 ? (
                <ImageGallery
                  items={carouselImages}
                  showThumbnails={!isFullscreen}
                  showFullscreenButton={true}
                  onScreenChange={handleScreenChange}
                />
              ) : (
                <div className="alert alert-danger d-flex align-items-center" role="alert">
                  <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: '24px', marginRight: '10px' }}></i>
                  <span>Inspection Pending/In Progress.</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <footer>
        <div className="container">
          <div className="row py-5 align-items-center">
            <div className="col-md-8 text-start">
              <img src={logo} className="img-fluid flogo" alt="fogo" />
              {/* <div className="socials">
                          <img src={goog} className="img-fluid" alt="goog" />
                          <img src={fac} className="img-fluid" alt="fac" />
                          <img src={lin} className="img-fluid" alt="lin" />
                          <img src={pin} className="img-fluid" alt="pin" />
                          <img src={ins} className="img-fluid" alt="ins" />
                        </div> */}
            </div>
            <div className="col-md-4">
              <h3>For Queries: </h3>
              <ul>
                <li>
                  <img src={a} className="img-fluid" alt="a" />
                  <a href="mailto:info@GearVu.com">info@GearVu.com</a>
                </li>
                <li>
                  <img src={mob} className="img-fluid" alt="mob" />
                  <a href="tel:18552168091">1.855.216.8091</a>
                </li>
                <li>
                  <img src={globe} className="img-fluid" alt="globe" />
                  <a href="https://GearVu.com" target="_blank" rel="noopener noreferrer">GearVu.com</a>
                </li>
                <li>
                  <img src={lin} className="img-fluid" alt="lin" />
                  <a href="https://www.linkedin.com/company/GearVu" target="_blank" rel="noopener noreferrer">GearVu</a>
                </li>
              </ul>
            </div>


          </div>
        </div>
      </footer>
      <div className="footer-bottom">
        <p>©2025, GearVu®  All rights reserved.</p>
      </div>
    </div>
  );
};

export default LiveReport;
